
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#323334","d":"M0 1.58V.43C0 .2.2.02.43.02h15.14c.24 0 .43.19.43.43v1.14a.43.43 0 01-.43.43H.43A.43.43 0 010 1.58zm.43 14.14A.43.43 0 010 15.3v-1.14c0-.24.2-.43.43-.43h15.14c.24 0 .43.2.43.43v1.14a.43.43 0 01-.43.43H.43zM11 5.01h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V6a1 1 0 011-1z"}})])
          )
        }
      }
    